// Traduce una respuesta de error del backend al motivo que ve el usuario. El
// backend habla varios formatos según la ruta: { errors: [...] } de validación,
// { message } de las plantillas, ProblemDetail { detail, title, bloqueos } de las
// campañas y { error } del manejador global y los filtros. Si no trae ninguno
// (un 413 de Nginx en HTML, por ejemplo), se explica el estado HTTP.

const POR_ESTADO = {
  401: 'La sesión ha caducado. Vuelve a entrar.',
  403: 'No tienes permiso para esta operación.',
  409: 'Conflicto: la operación ya existe o los datos cambiaron. Recarga e inténtalo de nuevo.',
  413: 'El fichero o la petición superan el tamaño máximo permitido.',
  429: 'Demasiadas operaciones seguidas. Espera un momento e inténtalo de nuevo.',
};

const conBloqueos = (texto, bloqueos) =>
  (Array.isArray(bloqueos) && bloqueos.length ? `${texto}: ${bloqueos.join('; ')}` : texto);

export const motivoDelError = (estado, data, reserva) => {
  if (data && Array.isArray(data.errors) && data.errors.length > 0) return data.errors.join(' · ');
  const texto = data && (data.message || data.detail || data.error || data.title);
  if (texto) return conBloqueos(texto, data.bloqueos);
  if (POR_ESTADO[estado]) return POR_ESTADO[estado];
  if (estado >= 500) {
    return `El servidor no respondió correctamente (HTTP ${estado}). Si se repite, contacta con el equipo de soporte.`;
  }
  return reserva;
};

// res.json() lanza si el cuerpo no es JSON; eso no es un error de conexión.
export const leerCuerpo = (res) => res.json().catch(() => ({}));
